exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-table[data-v-e26c52ce] {\n\t\tmargin-bottom: 20px;\n}\n.tables th[data-v-e26c52ce] {\n        border: none;\n}\n.button-page[data-v-e26c52ce] {\n        float:right;\n        margin-right: 0.5em;\n}\n.no-border[data-v-e26c52ce] {\n        border: hidden;\n        background: none;\n}\nth[data-v-e26c52ce] {\n        padding: 1em;\n}\ntd[data-v-e26c52ce] {\n        padding:1em;\n}\n", ""]);

// exports
